import React from 'react';

interface TrendingChartIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const TrendingChartIcon: React.FC<TrendingChartIconProps> = ({
  width = 20,
  height = 20,
  fill = 'currentColor',
  className = ''
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M17.2208 4.87341L9.99995 0.705078L2.78162 4.87341L9.99995 9.03924L17.2208 4.87341ZM10.8333 3.27591V6.60924H9.16662V3.27591H10.8333ZM18.0499 6.31924L10.8333 10.4826V18.8159L18.0499 14.6492V6.31841V6.31924ZM13.355 10.9751L16.2416 12.6417L15.4083 14.0851L12.5216 12.4184L13.355 10.9751ZM9.16662 18.8151V10.4817L1.94995 6.31758V14.6484L9.16662 18.8151ZM7.47912 12.4176L4.59245 14.0842L3.75912 12.6409L6.64578 10.9742L7.47912 12.4176Z" 
        fill={fill}
      />
    </svg>
  );
};

export default TrendingChartIcon;